import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";

import { setNewAddressObj } from "../../../redux/actions";
import {
  addToContacts,
  addToContactsMsg,
  existing,
  newTag,
} from "../../messages";
import Text from "../../text/Text";
import Button from "../../button/Button";
import { existingContactLabel, newContactLabel } from "../../constants";
import { contactIcon } from "../../images";
import CommonDrawer from "../../drawer/CommonDrawer";

function AddToContactDrawer({ openDrawer, setOpenDrawer, withdrawRequest }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleAdd = (contactLabel) => {
    dispatch(
      setNewAddressObj({
        withdraw_request: withdrawRequest,
        type: contactLabel,
      })
    );
    navigate(
      `/settings/contacts?withdraw_request=${withdrawRequest}&type=${contactLabel}`
    );
  };

  const renderBody = useCallback(() => {
    return (
      <Box className="logout-drawer-container" textAlign="center">
        <img src={contactIcon} height={44} width={44} />
        <Text size={20} font="bold">
          {addToContacts}
        </Text>
        <Text size={14} font="regular" className="grey-text">
          {addToContactsMsg}
        </Text>
        <Box
          className="logout-drawer-actions"
          display="flex"
          alignItems="center"
          gap={1}
          marginTop="16px"
        >
          <Button
            label={existing}
            variant="outlined"
            color="primary"
            sx={{
              width: "200px",
            }}
            onClick={() => {
              handleAdd(existingContactLabel);
            }}
          />
          <Button
            label={newTag}
            variant="contained"
            color="primary"
            sx={{
              width: "200px",
            }}
            onClick={() => {
              handleAdd(newContactLabel);
            }}
          />
        </Box>
      </Box>
    );
  }, []);

  return (
    <CommonDrawer
      anchor="bottom"
      open={openDrawer}
      onClose={() => setOpenDrawer(false)}
      className="add-to-contact-drawer"
    >
      {renderBody()}
    </CommonDrawer>
  );
}

export default AddToContactDrawer;
